/* eslint-disable */
import API from '@/api/api'

export default {
  //  Events
  GET_EVENTS ({ }) {
    return API.GET.events.all()
  },
  GET_ACTIVE_EVENT ({ }) {
    return API.GET.events.active()
  },
  SAVE_EVENT ({ }, data) {
    return API.POST.events(data)
  },
  UPDATE_EVENT ({ }, data) {
    return API.PUT.events.updateOne(data)
  },
  UPDATE_EVENT_DIVISION ({ }, data) {
    return API.PUT.events.updateDivisions(data)
  },
  DELETE_EVENT ({ }, data) {
    return API.DELETE.events(data)
  },
  //  Divisions
  GET_DIVISION ({ }) {
    return API.GET.divisions.all()
  },
  GET_JUDGE_DIVISIONS ({}, data){
    return API.GET.divisions.judge(data)
  },
  SAVE_DIVISION ({ }, data) {
    return API.POST.divisions(data)
  },
  UPDATE_DIVISION ({ }, data) {
    return API.PUT.divisions.updateOne(data)
  },
  UPDATE_DIVISION_EVENT ({ }, data) {
    return API.PUT.divisions.updateEvents(data)
  },
  UPDATE_JUDGE_DIVISION ({ }, data) {
    return API.PUT.users.updateDivisions(data)
  },
  //   Users
  UPDATE_USER ({ }, data) {
    return API.PUT.users.update(data)
  }
}
